<template>
    <header class="mc-pagehead">
        <div><h1>{{ title }}</h1><p v-if="subtitle">{{ subtitle }}</p></div>
        <div class="mc-actions">
            <span v-if="updated" :class="['mc-updated', { 'is-stale': stale }]">Aggiornato {{ updated }}</span>
            <slot name="actions" />
        </div>
    </header>
</template>
<script>
// Titolo = cosa, sottotitolo = la domanda a cui risponde la pagina. updated: testo da format.updatedAt().
export default {
    name: "McPageHeader",
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, default: "" },
        updated: { type: String, default: "" },
        stale: { type: Boolean, default: false },
    },
};
</script>
